import type { ErrorComponentProps } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { HeadContent } from "@tanstack/react-router";
import { useCallback, useEffect } from "react";
import { signOut } from "@/lib/client/auth";
import { ContactUs } from "./contact-us";
import { Button } from "@/components/ui/button";

function AppError({ error, reset }: ErrorComponentProps) {
  const handleReset = useCallback(async () => {
    await signOut();
    reset();
    window.location.reload();
  }, [reset]);

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  const errorMessage = error instanceof Error ? error.message : String(error);

  return (
    <html lang="zh" className="dark">
      <head>
        <HeadContent />
      </head>
      <body className="h-svh bg-background flex flex-col justify-center items-center space-y-4">
        <h1 className="text-2xl text-center font-bold text-red-500">服务器内部错误</h1>
        <p className="text-center text-red-400">肯定是很严重的报错！</p>
        <ContactUs />

        <Button className="mx-auto" onClick={handleReset}>
          重试
        </Button>

        <p className="text-center text-xs text-red-500">{errorMessage}</p>
      </body>
    </html>
  );
}

const AppErrorWithSentry = Sentry.withErrorBoundary(AppError, {});

export default AppErrorWithSentry;
